if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
        this._playTarget = null;
        this._onPlay = null;
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        const video_element = video_background_section.querySelector("video");
        if (video_element) {
          this._playTarget = hero_overlay;
          this._onPlay = () => this.playVideo(video_element);
          hero_overlay.addEventListener("touchstart", this._onPlay);
          hero_overlay.addEventListener("click", this._onPlay);
        }
      }

      checkAndPlayVideoSection(video) {
        const video_element = video.querySelector("video");
        if (video_element) {
          this._playTarget = video;
          this._onPlay = () => this.playVideo(video_element);
          video.addEventListener("touchstart", this._onPlay);
          video.addEventListener("click", this._onPlay);
        }
      }

      playVideo(video_element) {
        if (!video_element.playing) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this._playTarget && this._onPlay) {
          this._playTarget.removeEventListener("touchstart", this._onPlay);
          this._playTarget.removeEventListener("click", this._onPlay);
        }
        this._playTarget = null;
        this._onPlay = null;
      }
    },
  );
}
